import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';
import * as S from './tooltip-transition.styles';

export const TooltipTransitionComponent: React.ComponentType<
    TransitionProps & { children: React.ReactElement<any, any> }
> = props => {
    return <S.StyledGrow {...props} />;
};
